import React from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import PublishIcon from '@material-ui/icons/Publish';
import { useTranslation } from '../../src/i18n';
import Button from '../Button';
import { colors } from '../../constants/styleConstants';
import { TP } from '../../constants/consts';

const UploadFileButton = ({ accept, onFilesAdd, multiple, className, buttonProps, uploadButtonText }) => {
  const { t } = useTranslation();

  const onDrop = uploadedFiles => {
    const blobedFiles = uploadedFiles.map(file => {
      const reader = new FileReader();
      // eslint-disable-next-line no-unused-vars
      reader.onload = event => {
        // eslint-disable-next-line no-console
        console.log(`${accept} file uploaded`);
      };
      reader.readAsDataURL(file);
      return { ...file, filename: file.name, blob: reader, src: URL.createObjectURL(file), file };
    });
    onFilesAdd(blobedFiles);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop, accept, noDrag: true, multiple });

  return (
    <div className={className}>
      <div {...getRootProps()}>
        <input {...getInputProps()} accept={accept} />
        <Button color="default" endIcon={<PublishIcon style={{ color: colors.blue }} />} {...buttonProps}>
          {t(uploadButtonText)}
        </Button>
      </div>
    </div>
  );
};

UploadFileButton.propTypes = {
  className: PropTypes.string,
  accept: PropTypes.string, // 'image/*', '.pdf', 'text/*', 'file/*' and all variations of them
  multiple: PropTypes.bool,
  buttonProps: PropTypes.object,
  uploadButtonText: PropTypes.string,
};

UploadFileButton.defaultProps = {
  accept: 'image/*',
  multiple: false,
  className: '',
  buttonProps: {},
  uploadButtonText: `${TP}.FN_UPLOAD_MEDIA`,
};

export default UploadFileButton;
